module.exports = __webpack_public_path__ + "img/folderLink.513d5645.svg";